import { useCC9Flags } from "@dealer-center/core-third-party-launch-darkly";
import { BulkImportModal } from "./BulkImportModal";
import { PagesInventoryConfigUiConfigSelector } from "./ConfigSelector";
import styled from "styled-components";

const StyledTopArea = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  & > [cx-component="Modal"] {
    display: none;
  }
`;
interface TopAreaProps {
  selectedConfigName?: string;
  setSelectedConfigName: (value: string) => void;
  setIsNewConfig: (value: boolean) => void;
}
export const TopArea = ({
  selectedConfigName,
  setSelectedConfigName,
  setIsNewConfig
}: TopAreaProps) => {
  const {
    "cc9.website-inventory-config.show-bulk-import": shouldShowBulkImport
  } = useCC9Flags();
  return (
    <StyledTopArea>
      <PagesInventoryConfigUiConfigSelector
        id="display-config-selector"
        selectedConfigName={selectedConfigName}
        setIsNewConfig={setIsNewConfig}
        setSelectedConfigName={setSelectedConfigName}
      />
      {shouldShowBulkImport && <BulkImportModal sx={{ mt: 2 }} />}
    </StyledTopArea>
  );
};
